import { Card, CardContent, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'



function DataSuccessMessage({ message }: { message?: string }) {
    if (!message) return <></>
    return (
        <Card>
            <CardContent>
                <Stack direction={'column'} spacing={2}>
                    <Typography variant='subtitle2'>{t('training:flashCommentSection:title')}</Typography>

                    <Typography variant='subtitle2' fontWeight={400}>
                        <span dangerouslySetInnerHTML={{ __html: message }}></span>
                    </Typography>

                </Stack>

            </CardContent>
        </Card>
    )
}

export default DataSuccessMessage